import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import {
  IoMdLeaf,
  IoMdSunny,
  IoMdNutrition,
  IoMdFemale,
  IoMdPeople,
  IoMdGitNetwork,
  IoMdCheckmarkCircle
} from "react-icons/io";


import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';


import cln1 from '../assets/banner2.jpg';
import cln2 from '../assets/banner8.jpg';
import cln3 from '../assets/banner4.jpg';
import cln4 from '../assets/banner3.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">

										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
											}}
										>
											Women and Youth Empowerment
										</h1>
	
									</div>
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">

								<HorizontalImageStrip
									images={[cln1, cln2, cln3, cln4]}
								/>

								<h6
									style={{
										fontSize: "18px",
										marginTop: "45px",
										marginBottom: "35px",
										textTransform: "uppercase",
										textAlign: "center"
									
									}}
								>
									FPADI’s commitment to empowering women and youth underscores our belief that sustainable development must be &nbsp;
									<span className="text-secondary"><b>inclusive, equitable, and gender-responsive.</b></span> &nbsp;
									<hr />
								</h6>

								<h5>
									Learn how empowered women and youth in Tanzania, provided with the necessary tools and knowledge can gain confidence in transforming their lives and communities. The program had a profound impact on the lives of the women farmers. They gained new skills, improved the quality of their produce, and increased their crop yields, which led to a significant increase in their income.
									<br/><br/>
									Moreover, the women gained confidence, and their participation in decision-making within their households and communities increased. FPADI’s commitment to empowering women and youth underscores our belief that sustainable development must be inclusive, equitable, and gender-responsive.
									<br/>
									The Foundation for Poverty Alleviation and Development Initiatives (FPADI) recognized the importance of empowering women and youth in Tanzania, who often have limited access to resources and face several other challenges. To address this issue, FPADI is working towards ensuring empowered women are given the tools and freedom to make important decisions that shape their lives and navigate societal challenges. 
									<br/><br/>
									They have the opportunity to redefine traditional gender roles and other societal expectations, which allows them more freedom to pursue their goals. This empowerment promotes their self-worth, ability to make choices, and their right to bring about social change for themselves and others. Our program will take a holistic approach, ensuring youth are encouraged to take control of their own lives by improving their access to resources and transforming their mindset, beliefs, values, and attitudes. When young people feel empowered, they become confident and capable of actively contributing and collaborating, eagerly exploring their impact on the world around them.
									<br/><br/>
									FPADI, believes that women and youth empowerment is a powerful tool in reducing poverty. One key aspect of empowering women and youth is providing them with essential skills. By equipping them with these skills, they can not only support themselves but also assist others and invest for the future, thereby contributing to the economic growth of the nation. We firmly believe that women and youth empowerment is crucial for fostering innovation and implementing effective strategies to alleviate poverty. By giving individuals responsibility and power, we can create more value and stimulate innovation.
								</h5>

								
							</div>

						</div>

					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}